<template>
  <v-row>
    <v-col
      v-for="(picture, i) in pictures"
      :key="i"
      cols="12"
      md="2"
    >
      <v-card height="250">
        <v-img
          :src="picture.data"
          max-height="200"
          aspect-ratio="1.4"
        /></v-img>
        <v-card-subtitle>{{ picture.name }}</v-card-subtitle>
        <v-btn
          v-show="!isNewProduct"
          color="#e57373"
          fab
          dark
          outlined
          x-small
          absolute
          bottom
          right
          @click="deletePicture(picture.id, picture.name)"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: ["productPictures", "isNew"],
  data: () => (
    {

    }
  ),
  computed: {
    pictures(){
      return this.productPictures;
    },
    isNewProduct(){
      return this.isNew;
    },
  },
  methods: {
    deletePicture(pictureId, pictureName){
      this.$emit("delete", { id: pictureId, name: pictureName });
    },
  },
};
</script>